/**
 * Ma trận màn hình theo vai trò, chương 14 đặc tả giao diện.
 *
 * Nguyên tắc bắt buộc của chương 14:
 *   * màn hình không thuộc quyền của người dùng thì KHÔNG hiển thị trên điều hướng;
 *   * truy cập trực tiếp bằng đường dẫn thì trả về trang thông báo không có quyền,
 *     KHÔNG phải trang trắng.
 *
 * Ma trận của tài liệu viết theo vai trò; hệ thống lại phân quyền theo mã quyền
 * (bảng `quyen`). Bảng dưới đây ánh xạ từng màn hình sang mã quyền tương ứng, nên
 * thêm hay bớt vai trò về sau không phải sửa mã giao diện.
 */

/** Mã màn hình theo danh mục chương 2 đặc tả giao diện. */
export type MaManHinh =
  | 'MH-01'
  | 'MH-02'
  | 'MH-03'
  | 'MH-04'
  | 'MH-05'
  | 'MH-06'
  | 'MH-08'
  | 'MH-11'
  | 'MH-12'
  | 'MH-13'
  | 'MH-14'
  | 'MH-15'
  | 'MH-16'
  | 'MH-17'
  | 'MH-18'
  | 'MH-19'
  | 'MH-20'
  | 'MH-21'
  | 'MH-22'
  | 'MH-23'
  | 'MH-24'
  | 'MH-25'
  | 'MH-26'
  | 'MH-32'
  | 'MH-33'
  | 'MH-34'
  | 'MH-35'
  | 'MH-36'
  | 'MH-37'
  | 'MH-38'
  | 'MH-39';

/** Quyền cần có để MỞ màn hình. */
export const QUYEN_MAN_HINH: Record<MaManHinh, string> = {
  'MH-01': 'dashboard.read',
  'MH-02': 'device.read',
  'MH-03': 'device.read',
  'MH-04': 'device.create',
  'MH-05': 'device.read',
  'MH-06': 'device.create',
  'MH-08': 'device.control',
  'MH-11': 'bulletin.read',
  'MH-12': 'bulletin.create',
  'MH-13': 'bulletin.create',
  'MH-14': 'bulletin.approve',
  'MH-15': 'bulletin.read',
  'MH-16': 'broadcast.read',
  'MH-17': 'schedule.read',
  'MH-18': 'schedule.create',
  'MH-19': 'broadcast.play',
  'MH-20': 'broadcast.emergency',
  'MH-21': 'broadcast.relay',
  'MH-22': 'broadcast.live',
  'MH-23': 'broadcast.read',
  // Đợt 3 phần C3: bảng tin điện tử công cộng. Xem (danh sách/chi tiết bảng tin)
  // dùng `signage.read`; soạn bản tin và tạo lịch phát vòng lặp là thao tác thay
  // đổi dữ liệu nên dùng `signage.manage` — đúng cặp quyền đã seed ở migration
  // 013 và đã dùng sẵn ở `QUYEN_DIEU_HUONG['/bang-tin-dien-tu']` bên dưới.
  'MH-24': 'signage.read',
  'MH-25': 'signage.manage',
  'MH-26': 'signage.manage',
  // Đợt 3 phần C2: MH-32 báo cáo định kỳ, MH-33 thống kê thiết bị/bản tin.
  'MH-32': 'report.read',
  'MH-33': 'report.read',
  // Đợt 3 phần C4: quản trị người dùng/nhóm quyền, danh mục hành chính, nhật ký
  // thao tác, quản trị đa tỉnh. MH-40/41 (hồ sơ cá nhân, phiên đăng nhập) không
  // có ở đây: mọi người dùng đã đăng nhập đều xem được hồ sơ/phiên CỦA CHÍNH MÌNH,
  // không cần quyền riêng — bảo vệ bằng chính việc chỉ đọc theo phiên hiện tại.
  'MH-34': 'user.manage',
  'MH-35': 'user.manage',
  'MH-36': 'catalog.manage',
  'MH-37': 'catalog.manage',
  'MH-38': 'audit.read',
  'MH-39': 'platform.manage',
};

/** Quyền cần có để hiện MỘT MỤC trên thanh điều hướng bên. */
export const QUYEN_DIEU_HUONG: Record<string, string> = {
  '/tong-quan': 'dashboard.read',
  '/thiet-bi': 'device.read',
  '/ban-tin': 'bulletin.read',
  '/lich-phat': 'schedule.read',
  '/phat-song': 'broadcast.read',
  '/bang-tin-dien-tu': 'signage.read',
  '/bao-cao': 'report.read',
  '/thong-ke': 'report.read',
  '/tich-hop': 'integration.read',
  '/quan-tri/nha-cung-cap': 'vendor.manage',
  '/danh-muc': 'catalog.manage',
  '/quan-tri': 'user.manage',
};
